<template>
    <!-- Email input field -->
    <div :class="inputClass">
        <label
            class="input__label"
            :for="`${_uid}-input`"
            v-text="$t('COUPON_FIELD_OFFER_CODE')"/>
        <input
            :id="`${_uid}-input`"
            type="text"
            class="input__field uppercase"
            v-model.trim="couponCode"
            @change="validateCoupon(couponCode)">

        <!-- Validation -->
        <p class="input__message"
           v-if="isCouponInvalid"
           v-text="$t('COUPON_FIELD_SORRY')"/>

        <!-- success message -->
        <p class="input__message"
           v-if="!isCouponInvalid && coupon"
           v-text="coupon.successful_message"/>
    </div>
</template>

<script>
import debounce from 'lodash/debounce';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';
import CouponService from '@/services/coupons/CouponService';

export default {
    name: 'CouponField',
    props: {
        value: {
            default: null,
            type: String,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
    },
    data() {
        return {
            couponCode: null,
            coupon: null,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        inputClass() {
            if (this.isEmpty && this.isValid) {
                return 'input';
            }
            return !this.isCouponInvalid ? 'input input--success' : 'input input--invalid';
        },
        isCouponInvalid() {
            return this.errorHandler.has('coupon') || !this.isValid;
        },
        isEmpty() {
            return !(this.couponCode || '').length;
        },
    },
    methods: {
        /**
         * Handle validating the coupon with the API.
         *
         * @param {string} value
         *
         * @return void
         */
        validateCoupon(value) {
            this.coupon = null;
            if (!this.isEmpty) {
                CouponService.getAnyCouponByCouponCode(value)
                    .then(response => {
                        this.errorHandler.reset();
                        this.coupon = response.data.properties;
                    })
                    .catch(error => this.errorHandler.setResponse(error.response.data));
            } else {
                this.errorHandler.reset();
            }
        },
    },
    watch: {
        couponCode: debounce(function(value) {
            this.$emit('input', value);
            this.validateCoupon(value);
        }),
        value: {
            immediate: true,
            handler(value) {
                this.couponCode = value;
            },
        },
    },
};
</script>
